import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Subject} from 'rxjs';
import {Injectable} from '@angular/core';

export interface ConfirmRequest {
  text: string;
  resolve: (ok: boolean) => void;
}

@Injectable({providedIn: 'root'})
export class ConfirmService {
  private confirm$ = new Subject<ConfirmRequest | null>();
  readonly onConfirm = this.confirm$.asObservable();

  confirm(text: string): Promise<boolean> {
    return new Promise(resolve => {
      this.confirm$.next({text, resolve});
    });
  }

  answerConfirm(ok: boolean, req: ConfirmRequest | null): void {
    if (req) {
      req.resolve(ok);
      this.confirm$.next(null);
    }
  }
}

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="overlay" *ngIf="req">
      <div class="dialog">
        <img
          src="/assets/alerts/warning.svg"
          alt="Advertencia"
          class="dialog-icon"
        />
        <p>{{ req.text }}</p>
        <div class="buttons">
          <button class="btn-yes" (click)="respond(true)">Sí</button>
          <button class="btn-no"  (click)="respond(false)">No</button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    @keyframes popIn {
      0%   { transform: scale(0);    opacity: 0; }
      80%  { transform: scale(1.05); opacity: 1; }
      100% { transform: scale(1); }
    }

    .overlay {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.3);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
    }

    .dialog {
      background: #fff;
      padding: 1.5rem;
      border-radius: 6px;
      width: 320px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      text-align: center;
      transform-origin: center center;
      animation: popIn 250ms ease-out both;
    }

    .dialog-icon {
      display: block;
      margin: 0 auto 1rem;
      width: 48px;
      height: 48px;
    }

    .dialog p {
      font-size: 1.2rem;
      margin: 0 0 1.5rem;
      line-height: 1.4;
      font-family: 'Open Sans', sans-serif;
      color: #111;
    }

    .buttons {
      display: flex;
      justify-content: center;
      gap: 1rem;
    }

    .buttons button {
      min-width: 100px;
      padding: 0.6rem 1.2rem;
      border: none;
      border-radius: 4px;
      font-size: 1rem;
      font-family: 'Open Sans', sans-serif;
      font-weight: 600;
      cursor: pointer;
      transition: background-color 0.2s, transform 0.1s;
    }

    .buttons button:hover {
      transform: translateY(-1px);
    }

    .btn-yes {
      background: #3d3d40;
      color: #fff;
    }

    .btn-yes:hover { background: #2e2e2f; }

    .btn-no {
      background: #e0e0e0;
      color: #333;
    }

    .btn-no:hover { background: #cacaca; }
  `]
})
export class ConfirmDialogComponent {
  req: ConfirmRequest | null = null;

  constructor(private svc: ConfirmService) {
    this.svc.onConfirm.subscribe(r => this.req = r);
  }

  respond(ok: boolean): void {
    this.svc.answerConfirm(ok, this.req);
    this.req = null;
  }
}
